export enum EmailEntryMaxLengthsEnum {
  SUBJECT = 200,
  RECIPIENTS = 5000,
  CC = 5000,
}
